import { useState, useEffect } from "react";

//Components
import stellplatz from "../../assets/images/marker_Stellplatz.png";
import stellplatzVE from "../../assets/images/marker_Stellplatz_VE.png";
import entsorgungsstation from "../../assets/images/marker_Entsorgungsstation.png";
import markerpng from "../../assets/images/Marker_Google.png";
import premiumplatzVEpng from "../../assets/images/marker-pro-ve.png";
import premiumplatzpng from "../../assets/images/marker-pro.png";

const Markerroute = (options) => {
    const [marker, setMarker] = useState(null);
    if (!marker) {


        setMarker(
            new window.google.maps.Marker({
                href: `/map/pitch/${options.id}`,
                icon: {
                    url:
                        options.premium === "1" && options.marker === "Stellplatz "
                            ? premiumplatzpng
                            : options.premium === "1" &&
                            options.marker === "Stellplatz mit Entsorgungsstation"
                                ? premiumplatzVEpng
                                : options.premium !== "1" && options.marker === "Stellplatz"
                                    ? stellplatz
                                    : options.premium !== "1" &&
                                    options.marker === "Stellplatz mit Entsorgungsstation"
                                        ? stellplatzVE
                                        : options.premium !== "1" &&
                                        options.marker === "Entsorgungsstation"
                                            ? entsorgungsstation
                                            : markerpng,
                },
                optimized: false,
                title: options.id.toString(),
            })
        );
    }

    useEffect(() => {

        // remove marker from map on unmount
        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);

    useEffect(() => {
        if (marker) {
            marker.setOptions(options);

            if (options.name) {
                marker.addListener("click", () => {
                    let allcards = document.querySelectorAll(".infocard__cardwrapper");
                    for (let i = 0; i < allcards.length; i++) {
                        allcards[i].style.backgroundColor = "#f4f4f4";
                        let mapWrapper = document.querySelector(".search__maps")
                        mapWrapper.classList.remove("fullwidth");
                    }
                    const element = document.getElementById(options.id);
                    if (element) {
                        element.style.background = "#d7d7d7";

                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                });
            }
        }
    }, [marker, options]);
    return null;
};



export default Markerroute;
